export default "__VITE_ASSET__CAF5D2lc__"